import AxioInstance from "../../api/AxiosInstance";

//get request
let UsersBatchList = async (token) => {
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data } = await AxioInstance.get("users/batches", config);
  //(data)
  // //(data)
  return data;
};

let UsersGroupList = async (token) => {
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data } = await AxioInstance.get("users/groups", config);
  return data;
};

const userBatchListService = {
  UsersBatchList,
  UsersGroupList
};

export default userBatchListService;
